import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const kingArthurQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-wishlist-added",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/king-arthur-legends-rise/KingArthurLegendsRiseTrailer.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-trailer-watched",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/aXxgu2hhUq",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-discord-followed",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow King Arthur on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/PlayKingArthur",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-twitter-followed",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-twitter",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Check out Netmarble's Creator Forum",
    caption: "Get the latest updates on the Netmarble Creator Program",
    linkUrl: "https://forum.netmarble.com/mbxcreator",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "d3592704-8398-4b2b-bb1d-ffd1c200354b-website-creator-forum-visited",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-website-creator-forum",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Support a King Arthur: Legends Rise creator",
    caption: "Find and support your favourite content creator",
    linkUrl: "https://creator.netmarble.com/en/m/kingarthur",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "d3592704-8398-4b2b-bb1d-ffd1c200354b-website-support-creator-visited",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-website-support-creator",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-onboarding-completed",
    ruleId: "d3592704-8398-4b2b-bb1d-ffd1c200354b-onboarding",
  },
];

export const kingArthurQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 50,
    quests: kingArthurQuestsList,
  },
];
